import { ISandboxMarker } from "../interfaces";

/**
 * Converte um array de marcadores para um formato compatível com o MarkerLayer,
 * transformando as coordenadas em números e filtrando coordenadas inválidas.
 * Também adiciona dados do veículo e uma função getter para o marcador.
 */
export const convertMarkerPositionsToNumber = (markers: ISandboxMarker[]): ISandboxMarker[] => {
    return markers
      .map((marker: any) => {
        return ({
          ...marker,
          id: marker.id,
          lat: Number(marker.position.lat),
          lng: Number(marker.position.lng),
          data: { vehicleId: marker.id },
          getData: () => marker,
        })
      })
      .filter((m) => !isNaN(m.lat) && !isNaN(m.lng) && m.lat >= -90 && m.lat <= 90 && m.lng >= -180 && m.lng <= 180);
  }
